//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Fly from 'flyio/dist/npm/fly'

export default {
    name: 'IndexFooter',
    data() {
        return {
            dataArray:[],
            showCardIndex: 0,
            openCard:true
        }
    },
    methods: {
        myConsultant() {
                this.showCardIndex = 1
                this.openCard = false
                 if(this.dataArray===''){
                    console.log(1)
                    let fly = new Fly() // 创建fly实例
                    // fly.config.withCredentials = true  // 跨域时是否发送cookie
                    fly.request('https://api.ruan.net/api/personal/customer_service', {}, {
                        method: 'get'
                    }).then(resp => {
                        console.log(resp,123)
                        if (resp.data.status === 200) {
                            this.showCardIndex = 1
                            this.dataArray = resp.data.data
                            sessionStorage.setItem('objArr', JSON.stringify(resp.data.data))
                        }
                    }).catch((e) => console.log('error', e))
                }else{
                     this.dataArray = JSON.parse(sessionStorage.getItem('objArr'))
                }
        },
        closeMask(e) {
            if (!(event.target).closest('.footer-card')) {
                this.showCardIndex = 0
                this.openCard = true
            }
        },
        btnCloseMask() {
            this.openCard = true
            this.showCardIndex = 0
        }
    },
    created() {
        this.dataArray = JSON.parse(sessionStorage.getItem('objArr'))?JSON.parse(sessionStorage.getItem('objArr')):''
    }
}



// WEBPACK FOOTER //
// ./src/components/IndexFooter.vue